import { render, staticRenderFns } from "./CybermatR2.vue?vue&type=template&id=45a6107a&scoped=true"
import script from "./CybermatR2.vue?vue&type=script&lang=ts"
export * from "./CybermatR2.vue?vue&type=script&lang=ts"
import style0 from "./CybermatR2.vue?vue&type=style&index=0&id=45a6107a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6107a",
  null
  
)

export default component.exports